import React from "react";
import { Typography, Button, Box, Alert, CircularProgress } from "@mui/material";

interface ProcessingStepProps {
  processingError: string | null;
  onBackToUpload: () => void;
}

const ProcessingStep: React.FC<ProcessingStepProps> = ({
  processingError,
  onBackToUpload,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        py: 6,
        gap: 3,
      }}
    >
      {processingError ? (
        <>
          <Alert severity="error" sx={{ width: "100%", maxWidth: 480 }}>
            {processingError}
          </Alert>
          <Button
            variant="outlined"
            sx={{ textTransform: "none", borderRadius: 2 }}
            onClick={onBackToUpload}
          >
            Back to Upload
          </Button>
        </>
      ) : (
        <>
          <CircularProgress size={56} />
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
              Processing Your File
            </Typography>
            <Typography variant="body2" color="text.secondary">
              The AI is analyzing your template. This may take a few minutes.
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
};

export default ProcessingStep;
